import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  AfterContentInit,
} from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { TransformObjectFormService } from '../../utils/transform-object-form/transform-object-form.service';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import * as Cookies from 'js-cookie';
export class TNKAuthLoanSliderComponent implements OnInit, AfterContentInit {
public submitBusy: boolean = false;
public widgetEnabled: boolean = false;
public failGetData: boolean = false;
public loanData: any = null;
public invalidSliderForm: boolean = false;
public sliderData: any = {
    loanMinimum: 2000000,
    loanAmount: 12000000,
    loanPeriod: 12,
    loanPurpose: '0',
    loanMonthly: 0,
  };
public remainingLoan: string;
public accessToken: string;
public errorServerURI: string;
public successURI: string;
public formURI: string;
public sliderType: string;
/**
 * @param {?} http
 * @param {?} api
 * @param {?} router
 * @param {?} transformObject
 */
constructor(
private http: HttpClient,
private api: ApiConstant,
private router: Router,
private transformObject: TransformObjectFormService,
  ) {}
/**
 * @return {?}
 */
ngOnInit() {
    this.getInitialData();
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    this.calcInitSlider();
    this.calcInitMonthly();
  }
/**
 * @return {?}
 */
public getInitialData() {
    this.http
      .get(`${this.api.apiURL}/user/profile?tnk_token=${this.accessToken}`)
      .subscribe(
        (data: any) => {
          this.widgetEnabled = true;
          this.loanData = data.result.newLoanInfo;
        },
        (error: HttpErrorResponse) => {
          this.widgetEnabled = false;
          this.failGetData = true;
        },
      );
  }
/**
 * @return {?}
 */
public calcInitSlider(): void {
    const /** @type {?} */ remainingLoanForTopupCookie = Cookies.get('tnk_topup');
    if (
      (this.sliderType === 'topup' && this.remainingLoan) ||
      remainingLoanForTopupCookie
    ) {
      if (remainingLoanForTopupCookie) {
        // This will handle if user hard refresh in second loan slider page.
        // If we didn't handle hard refresh, loan minimum slider data will reset to default (2 million)
        this.sliderData.loanMinimum = this.calculateSliderLoanMinimun(
          remainingLoanForTopupCookie,
        );
      } else {
        // This block will handle if user normaly top up and not hard refresh in second loan slider page
        // Which remainingLoan get from parent of this component (dashboard-second-loan-slider.component)
        this.sliderData.loanMinimum = this.calculateSliderLoanMinimun(
          this.remainingLoan,
        );
      }
      if (this.sliderData.loanMinimum > this.sliderData.loanAmount) {
        this.sliderData.loanAmount = this.sliderData.loanMinimum;
      }
    }
  }
/**
 * \@description method to calculate loanMinimun for slider topup
 * @param {?} remainingLoan
 * @return {?}
 */
private calculateSliderLoanMinimun(remainingLoan: string): number {
    return Math.ceil(parseInt(remainingLoan, 10) / 1000000) * 1000000 + 2000000;
  }
/**
 * * \@description initialize monthly calculation
 * * \@return <number> to currency string
 * * \@method calcInitMonthly()
 * @return {?}
 */
private calcInitMonthly() {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];

    const /** @type {?} */ loanAmount = this.sliderData.loanAmount;
    const /** @type {?} */ loanPeriod = this.sliderData.loanPeriod;

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    ret[0] = monthlyPaymentRaw;
    ret[1] = monthlyPaymentRaw * loanPeriod;

    this.sliderData.loanMonthly = ret[0];
  }
/**
 * @param {?=} event
 * @param {?=} type
 * @return {?}
 */
private calcMonthly(event?: any, type?: string): void {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];
    let /** @type {?} */ loanAmount = 0;
    let /** @type {?} */ loanPeriod = 0;

    if (event && type === 'amount') {
      loanAmount = parseInt(event.value);
      this.sliderData.loanAmount = loanAmount;
    } else if (event && type === 'period') {
      loanPeriod = parseInt(event.value);
      this.sliderData.loanPeriod = loanPeriod;
    }

    loanAmount = this.sliderData.loanAmount;
    loanPeriod = this.sliderData.loanPeriod;

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    ret[0] = monthlyPaymentRaw;
    ret[1] = monthlyPaymentRaw * loanPeriod;

    this.sliderData.loanMonthly = ret[0];
  }
/**
 * @return {?}
 */
public submitLoan() {
    if (this.sliderData.loanPurpose === '0') {
      this.invalidSliderForm = true;
    } else {
      const /** @type {?} */ loanData = ( /** @type {?} */((<any>Object))).assign({}, this.loanData);

      loanData.loanAmount = this.sliderData.loanAmount;
      loanData.loanPeriodInMonths = this.sliderData.loanPeriod;
      loanData.loanPurposeType = this.sliderData.loanPurpose;
      loanData.mediasource = 'ShortApp';
      loanData.referralCode =
        this.sliderType === 'topup' ? 'TNKTOPUP' : 'TNK2ND';

      const /** @type {?} */ fixedLoanData = ( /** @type {?} */((<any>Object))).assign(
        {},
        this.transformObject.sliderAuthModel(loanData),
      );

      if (!this.submitBusy) {
        this.submitBusy = true;

        // Set loan data from slider so it is accessible in second loan form.
        Cookies.set('TNK-SL-SLRDATA', JSON.stringify(this.sliderData), {
          expires: 365,
        });

        // Navigate to second loan form.
        setTimeout(() => {
          this.router.navigateByUrl(this.formURI);
        }, 100);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'auth-loan-slider',
  template: `
    <div class="loan__slider__widget--disabled " *ngIf="!widgetEnabled">
      <p>Sedang Mengambil data pinjaman....</p>
    </div>

    <!-- <div class="loan__slider__widget--error " *ngIf="failGetData">
    	<p>Terjadi Kesalahan..</p>
    	<button>Coba lagi..</button>
    </div> -->

    <div class="loan__slider__widget" *ngIf="widgetEnabled">
      <div class="card card--loan-slider card--bg-blue card--no-padding">
        <div class="col-sm-3 col-xs-4">
          <p class="loan__description text--left text--clr-white">
            Cicilan
            <br />
            mulai dari:
          </p>
        </div>

        <div class="col-sm-9 col-xs-8">
          <p class="align--right text--padding-top">
            <span class="loan__amount">
              {{ sliderData.loanMonthly | tnkCurrency: 'rupiah' }},-
            </span>
            <br />
            <span>per bulan</span>
          </p>
        </div>
      </div>

      <div class="card card--loan-slider">
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <p class="help-block">Jumlah Pinjaman</p>
          </div>

          <div class="col-sm-6 col-xs-6 align--right">
            <p class="slider-title">
              {{ 'Rp ' + sliderData.loanAmount / 1000000 + ' juta' }}
            </p>
          </div>
        </div>

        <div class="row row--slider">
          <div class="col-sm-12">
            <div class="col-sm-1 col-xs-1" style="padding: 0">
              <p class="loan__description">
                {{ this.sliderData.loanMinimum / 1000000 }}
              </p>
            </div>

            <div class="col-sm-10 col-xs-10" style="padding: 0">
              <mat-slider
                [min]="sliderData.loanMinimum"
                [max]="20000000"
                [(ngModel)]="sliderData.loanAmount"
                [step]="1000000"
                (input)="calcMonthly($event, 'amount')"
              ></mat-slider>
            </div>

            <div class="col-sm-1 col-xs-1" style="padding: 0">
              <p class="loan__description">20</p>
            </div>
          </div>
        </div>
      </div>

      <div class="card card--loan-slider">
        <div class="row">
          <div class="col-sm-6 col-xs-6">
            <p class="help-block">Periode Pinjaman</p>
          </div>

          <div class="col-sm-6 col-xs-6 align--right">
            <p class="slider-title">{{ sliderData.loanPeriod + ' bulan' }}</p>
          </div>
        </div>

        <div class="row row--slider">
          <div class="col-sm-12">
            <div class="col-sm-1 col-xs-1" style="padding: 0">
              <p class="loan__description">6</p>
            </div>

            <div class="col-sm-10 col-xs-10" style="padding: 0">
              <mat-slider
                [min]="6"
                [max]="20"
                [(ngModel)]="sliderData.loanPeriod"
                [step]="1"
                (input)="calcMonthly($event, 'period')"
              ></mat-slider>
            </div>

            <div class="col-sm-1 col-xs-1" style="padding: 0">
              <p class="loan__description">20</p>
            </div>
          </div>
        </div>
      </div>

      <div class="card card--loan-slider">
        <div class="row">
          <div class="form-group" [ngClass]="{ 'has-error': invalidSliderForm }">
            <div class="col-sm-5 col-xs-5">
              <p class="help-block" style="margin-top: 10px">Tujuan Pinjaman</p>
            </div>

            <div class="col-sm-7 col-xs-7">
              <select
                class="form-control"
                id="reviewField_tujuan_meminjam"
                [(ngModel)]="sliderData.loanPurpose"
                name="loan_purpose"
              >
                <option value="0">Pilih salah satu</option>
                <option value="Holiday">Liburan</option>
                <option value="HousingLoan">KPR</option>
                <option value="CarOrMotorcycle">Mobil/Motor</option>
                <option value="CreditCard">Kartu Kredit</option>
                <option value="Renovation">Renovasi</option>
                <option value="ElectronicUnsecuredLoan">KTA Elektronik</option>
                <option value="Education">Sekolah</option>
                <option value="VentureCapital">Modal Usaha</option>
                <option value="Investment">Investasi</option>
                <option value="Other">Lainnya</option>
              </select>
              <p class="help-block help-block-error" *ngIf="invalidSliderForm">
                Tujuan pinjaman wajib dipilih
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <button
            id="pinjamlagi_AjukanPinjaman"
            class="tnk__button button--green button--block"
            (click)="submitLoan()"
            [disabled]="submitBusy"
          >
            {{ submitBusy ? 'Loading...' : 'Ajukan Pinjaman' }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    html {
      font-size: 14px;
    }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
    }
    #loan-slider .card__header {
      background-color: #004c7b;
      color: #fff;
    }
    .pd-left-right-20 {
      padding-left: 20px;
      padding-right: 20px;
    }
    .separator {
      position: relative;
      width: 100%;
      height: 1px;
      display: block;
      overflow: hidden;
      background-color: #ececec;
      margin: 5px auto;
    }
    .separator:after {
      content: ' ';
    }
    .table.table--borderless td,
    .table.table--borderless th {
      border: none;
    }
    .table.table--borderless td {
      font-size: 14px;
    }
    .separator {
      position: relative;
      display: block;
      height: 1px;
      width: 100%;
      background-color: #ccc;
      margin-bottom: 10px;
    }
    .no--margin {
      margin: 0 !important;
    }
    a.link {
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
    }
    a.link.link--clr-blue:link {
      color: #004c7b;
    }
    .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group {
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
    }
    .form-wrapper .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group .help-block {
      font-size: 13px;
    }
    .form-wrapper .form-group .help-block.label--control {
      color: #444;
    }
    .form-wrapper .form-group .col-sm-* p {
      margin-bottom: 15px;
    }
    a.tnk__button {
      text-decoration: none;
    }
    .tnk__button {
      position: relative;
      display: inline-block;
      min-width: 70px;
      padding: 10px;
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      outline: 0;
      cursor: pointer;
      border: 1px solid transparent;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin: 0 auto;
      border-radius: 35px;
      -webkit-box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
              box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
      text-transform: uppercase;
      margin-top: 15px;
    }
    .tnk__button[disabled] {
      cursor: not-allowed;
    }
    .tnk__button.button--sm {
      font-size: 12px;
    }
    .tnk__button.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
    }
    .tnk__button.button--block {
      min-width: 100%;
      width: 100%;
      padding: 10px 0;
    }
    .tnk__button.button--float-right {
      float: right;
      margin-right: 10px;
    }
    .tnk__button.button--float-left {
      float: left;
      margin-left: 10px;
    }
    .tnk__button.button--min {
      width: 110px;
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    .tnk__button.button--green {
      font-size: 12px;
      color: #fff;
      background-color: #81be41;
    }
    .tnk__button.button--green.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--green:hover {
      background-color: #72b63e;
    }
    .tnk__button.button--green:active {
      color: #f2f2f2;
      bakground-color: #6ab631;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--green[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--green.button--sm {
      -webkit-box-shadow: none;
              box-shadow: none;
      padding: 8.5px 10px;
    }
    .tnk__button.button--blue {
      background-color: #1a72a4;
      color: #fff;
      font-size: 12px;
    }
    .tnk__button.button--blue.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--blue:hover {
      background-color: #1e6a94;
      color: #fff;
    }
    .tnk__button.button--blue:active {
      color: #f2f2f2;
      background-color: #004c7b;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--blue[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--blue.button--min {
      font-size: 10px;
    }
    .tnk__button.button--red {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole {
      border-radius: 16.5px;
      padding: 7px 10px;
    }
    .tnk__button.button--hole.button--red {
      background-color: #fff;
      border: 2px solid #721c24;
      color: #721c24;
    }
    .tnk__button.button--hole.button--red:hover,
    .tnk__button.button--hole.button--red :active {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole.button--green {
      background-color: transparent;
      border: 2px solid #81be41;
      color: #81be41;
    }
    .tnk__button.button--hole.button--green.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--green.button--active {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--green.button--active:hover,
    .tnk__button.button--hole.button--green.button--active :active {
      background-color: #6ab631;
    }
    .tnk__button.button--hole.button--green:hover {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue {
      background-color: transparent;
      border: 2px solid #1a72a4;
      color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--blue.button--active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue.button--active:hover,
    .tnk__button.button--hole.button--blue.button--active :active {
      background-color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue:hover,
    .tnk__button.button--hole.button--blue :active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue[disabled] {
      border: 2px solid transparent;
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--margin-sm {
      margin-top: 5px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button.button--margin-md {
      margin-top: 10px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button .icon {
      margin-right: 10px;
    }
    .tnk__modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5000;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background-color: rgba(0,0,0,0.75);
    }
    .tnk__modal .modal__inner {
      position: relative;
      border-radius: 8px;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
              box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
      width: 80%;
      min-height: 240px;
      margin: 7.5% auto 0;
      display: block;
    }
    .tnk__modal .modal__inner.modal--size-small {
      width: 30%;
      border-radius: 8px;
      min-height: 120px;
      margin: 0 auto;
    }
    .tnk__modal .modal__inner.modal--size-small .modal__content {
      margin-top: 25vh;
      padding: 30px;
    }
    .tnk__modal .modal__inner .modal__content {
      position: relative;
      display: block;
      overflow: hidden;
    }
    .tnk__modal .modal__inner .modal__content.content--align-center {
      text-align: center;
    }
    .tnk__modal .modal__inner .modal__content h4 {
      font-size: 22px;
      color: #81be41;
    }
    .tnk__modal .modal__inner .modal__content .head__icon {
      font-size: 48px;
    }
    .tnk__modal .modal__inner .modal__content p {
      color: #8a8989;
      margin-top: 28px;
    }
    .checkbox__wrapper {
      position: relative;
      display: block;
      overflow: hidden;
      background-color: #cfe6f0;
      padding: 20px 30px;
      border-radius: 5px;
      margin: 0 0 10px;
    }
    .checkbox__wrapper.has-error {
      background-color: #f2dede;
    }
    .checkbox__wrapper.has-error p {
      color: #721c24;
    }
    .checkbox__wrapper label {
      color: #191919;
    }
    .checkbox__wrapper label input[type=checkbox] {
      width: 16px;
      height: 16px;
      margin-left: -25px;
      margin-top: 3px;
    }
    .birth__province {
      padding-left: 0 !important;
    }
    .birth__city {
      padding-right: 0 !important;
    }
    @media screen and (min-width: 240px) and (max-width: 800px) {
      .birth__province {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .birth__city {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .tnk__button.button--margin-sm {
        min-width: 42.5%;
      }
      .tnk__button.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--hole.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--float-left {
        margin-left: 0;
      }
      .tnk__modal .modal__inner.modal--size-small {
        width: 100%;
        border-radius: 0;
        min-height: 100vh;
      }
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        margin-top: 0;
        padding: 0;
        padding-top: 25vh;
      }
    }
    @media screen and (max-width: 1024px) {
      .tnk__button.button--hole.button--green:active {
        background-color: #81be41;
        color: #fff;
      }
    }
    @media screen and (min-width: 1024px) {
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        padding-top: 25;
      }
      .checkbox__wrapper {
        margin: 0 0 10px;
      }
    }
    mat-slider {
      width: 100%;
    }
    .mat-accent .mat-slider-thumb,
    .mat-accent .mat-slider-thumb-label,
    .mat-accent .mat-slider-track-fill {
      background-color: #81be41;
    }
    .noUi-connect {
      background: #81be41;
    }
    .loan__slider__widget {
      position: relative;
      margin: 5px;
      border-radius: 5px;
      background-color: #fff;
      -webkit-box-shadow: 0px -2px 9px 1px rgba(28,28,28,0.4);
              box-shadow: 0px -2px 9px 1px rgba(28,28,28,0.4);
      overflow: hidden;
      display: block;
    }
    .loan__slider__widget.widget--embed {
      -webkit-box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
              box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
      border-radius: 5px 5px 0 0;
      margin: 5px 2.9px 0 2.9px;
    }
    .loan__slider__widget .align--right {
      text-align: right;
    }
    .loan__slider__widget .align--center {
      text-align: center;
    }
    .loan__slider__widget .text--padding-top {
      padding-top: 10px;
    }
    .loan__slider__widget .row {
      position: relative;
      display: block;
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
    }
    .loan__slider__widget .row.row--slider {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 0;
      padding-bottom: 5px;
    }
    .loan__slider__widget .row.row--slider input {
      outline: none;
    }
    .loan__slider__widget .card.card--loan-slider {
      position: relative;
      display: block;
      overflow: hidden;
      border-bottom: solid 1px #ccc;
      margin: 0 5px;
      padding: 15px 0 5px;
      font-size: 20px;
      font-weight: bold;
    }
    .loan__slider__widget .card.card--loan-slider:last-child {
      border-bottom: 0;
    }
    .loan__slider__widget .card.card--loan-slider button {
      margin-bottom: 15px;
    }
    .loan__slider__widget .card.card--loan-content {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 17px 0 15px;
      border-radius: 5px 5px 0 0;
    }
    .loan__slider__widget .card.card--loan-content p,
    .loan__slider__widget .card.card--loan-content a.link:link {
      font-size: 13px;
      margin-bottom: 13px;
    }
    .loan__slider__widget .card.card--loan-content h2 {
      font-size: 18px;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin-bottom: 30px;
      line-height: 1.5em;
    }
    .loan__slider__widget .card.card--loan-content.no--pd-top {
      padding-top: 0;
    }
    .loan__slider__widget .card.card--loan-content.no--pd-bot {
      padding-bottom: 0;
    }
    .loan__slider__widget .card.card--loan-content .tnk-list {
      color: #444;
    }
    .loan__slider__widget .card.card--bg-grey {
      background-color: #ececec;
    }
    .loan__slider__widget .card.card--bg-blue {
      background-color: #004c7b;
      color: #fff;
      margin: 0;
      border-radius: 5px 5px 0 0;
    }
    .loan__slider__widget .card.card--no-padding {
      padding-top: 10px;
      padding-bottom: 5px;
    }
    .loan__slider__widget .card.card--confirm-action {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 18px;
      text-align: left;
    }
    .loan__slider__widget .card span,
    .loan__slider__widget .card p {
      font-family: 'HelveticaLight', sans-serif;
      font-size: 13px;
    }
    .loan__slider__widget .card p {
      color: #555;
    }
    .loan__slider__widget .card p span {
      color: #fff;
    }
    .loan__slider__widget .card span.loan__amount {
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      font-size: 21px;
      color: #fff;
    }
    .loan__slider__widget .card h2 {
      color: #535353;
    }
    .loan__slider__widget .card .mat-slider-horizontal {
      height: 40px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-wrapper {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-background {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-fill {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-wrapper {
      height: 5px;
    }
    .loan__slider__widget .card p.help-block {
      font-weight: bold;
      font-size: 14px;
    }
    .loan__slider__widget .card p.help-block span {
      color: #fff;
    }
    .loan__slider__widget .card p.help-block-error {
      color: #a94442;
    }
    .loan__slider__widget .card span.back__circle {
      border-radius: 100%;
      background-color: #004c7b;
      color: #fff;
      padding: 3px 5px;
      font-weight: bold;
      font-size: 11px;
    }
    .loan__slider__widget .card .table td {
      color: #535353;
    }
    .loan__slider__widget .card .loan__description {
      text-align: center;
      position: relative;
      margin-top: 15px;
    font-size
      color: #8a8989;
      font-weight: bold;
    }
    .loan__slider__widget .card .loan__description.text--big {
      font-size: 16px;
    }
    .loan__slider__widget .card .loan__description.text--sm {
      font-size: 11px;
    }
    .loan__slider__widget .card .loan__description.text--left {
      text-align: left;
    }
    .loan__slider__widget .card .loan__description.text--clr-white {
      color: #fff;
    }
    .loan__slider__widget .card .slider-title {
      font-size: 18px;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
      color: #7f7f7f;
    }
    .loan__slider__widget input[type=range] {
      height: auto;
      -webkit-appearance: none;
      margin: 14px 0 0 0;
      width: 100%;
      outline: none;
    }
    .loan__slider__widget input[type=range]:focus {
      outline: none;
    }
    .loan__slider__widget input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      border: none;
      -webkit-box-shadow: 0px 0px 0px #000;
              box-shadow: 0px 0px 0px #000;
      background: #ececec;
      border-radius: 25px;
    }
    .loan__slider__widget input[type=range]::-webkit-slider-thumb {
      -webkit-box-shadow: 0px 0px 0px #000;
              box-shadow: 0px 0px 0px #000;
      height: 24px;
      width: 24px;
      border: none;
      border-radius: 100%;
      background-color: #81be41;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -10px;
    }
    .loan__slider__widget input[type=range]::-moz-range-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      animate: 0.2s;
      box-shadow: 0px 0px 0px #000;
      background: #ececec;
      border-radius: 25px;
      border: 0px solid #000101;
    }
    .loan__slider__widget input[type=range]::-moz-range-thumb {
      box-shadow: 0px 0px 0px #000;
      border: 0px solid #000;
      height: 24px;
      width: 24px;
      outline: none;
      border-radius: 100%;
      background: #81be41;
      cursor: pointer;
      margin-top: -14px;
    }
    .loan__slider__widget input[type=range]::-ms-track {
      width: 100%;
      height: 13px;
      cursor: pointer;
      animate: 0.2s;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }
    .loan__slider__widget input[type=range]::-ms-fill-lower {
      background: #ececec;
      border: none;
      border-radius: 50px;
      box-shadow: 0px 0px 0px #000;
    }
    .loan__slider__widget input[type=range]::-ms-fill-upper {
      background: #ececec;
      border: none;
      border-radius: 50px;
      box-shadow: 0px 0px 0px #000;
    }
    .loan__slider__widget input[type=range]::-ms-thumb {
      margin-top: 1px;
      box-shadow: 0px 0px 0px #000;
      border: none;
      height: 24px;
      width: 24px;
      border-radius: 100%;
      background: #81be41;
      cursor: pointer;
    }
    .loan__slider__widget .col-sm-* {
      position: relative;
    }
    @media screen and (min-width: 320px) and (max-width: 400px) {
      .loan__slider__widget .card p.help-block {
        margin-top: 5px;
        font-size: 12px;
      }
    }
    @media screen and (max-width: 320px) {
      .tnk__button {
        width: 100%;
      }
      .tnk__button.button--float-right {
        margin: 10px 0 0;
      }
    }
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  `],
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
{type: ApiConstant, },
{type: Router, },
{type: TransformObjectFormService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'remainingLoan': [{ type: Input, args: ['remainingLoan', ] },],
'accessToken': [{ type: Input, args: ['accessToken', ] },],
'errorServerURI': [{ type: Input, args: ['errorServerURI', ] },],
'successURI': [{ type: Input, args: ['successURI', ] },],
'formURI': [{ type: Input, args: ['formURI', ] },],
'sliderType': [{ type: Input, args: ['sliderType', ] },],
};
}

function TNKAuthLoanSliderComponent_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthLoanSliderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthLoanSliderComponent.ctorParameters;
/** @type {?} */
TNKAuthLoanSliderComponent.propDecorators;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.submitBusy;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.widgetEnabled;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.failGetData;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.loanData;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.invalidSliderForm;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.sliderData;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.remainingLoan;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.accessToken;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.errorServerURI;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.successURI;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.formURI;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.sliderType;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.http;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.api;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.router;
/** @type {?} */
TNKAuthLoanSliderComponent.prototype.transformObject;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
